import Vue from 'vue'
import store from '@/store'
import VueGtm from '@gtm-support/vue2-gtm'
import router from '@/router/index.js'
import { ENV_KEY } from '@/constants/env'

Vue.use(VueGtm, {
  id: store.getters['env/GET_KEY'](ENV_KEY.GTM_ID),
  vueRouter: router,
  trackOnNextTick: true,
})
